import { Component, TemplateRef, input, HostAttributeToken, inject } from '@angular/core';
import { filter, map, Observable } from "rxjs";
import { TeleportService } from "./teleport.service";

@Component({
    selector: 'vm-teleport',
    template: '<ng-container *ngTemplateOutlet="template$ | async; context: context()"></ng-container>',
    standalone: false
})
export class TeleportComponent {
  private teleportService = inject(TeleportService);


  readonly template$: Observable<TemplateRef<any> | null>;

  readonly context = input<any>();

  constructor() {
    const name = inject(new HostAttributeToken('name'));
    const teleportService = this.teleportService;

    this.template$ = teleportService.pipe(
      filter(instance => ! instance || (name in instance)),
      map(instance => instance && instance[name])
    );
  }

}
